// About section content.
module.exports = {
  overline: "About Me",
  title: "Know Me More",
  heading: "I'm Will Laws, a Technology Leader & Solutions Architect.",
  paragraphs: [
    "Technology leader who modernises platforms, strengthens governance, and builds teams that ship. Building on AWS since 2009 — before the launch of RDS. Currently serving as Senior Solutions Architect at AWS, advising Australia's largest financial services and technology organisations on cloud transformation, operational resilience, and cybersecurity.",
    "I work across payments, lending, digital marketplaces, SaaS platforms, and high-growth startups, helping organisations from early-stage to national infrastructure scale. Previously led technology strategy for an enterprise SaaS provider, scaling operations and positioning the platform for successful acquisition. I co-founded an EdTech startup and speak at AWS re:Invent on operational excellence and resilience.",
  ],
  // Raw numbers. Derived values (e.g. current year minus awsStartYear) are
  // computed by whichever consumer renders the stats.
  certCount: 12,
  communityCount: 200,
  reInventAppearances: 3,
};
